module.exports = __webpack_public_path__ + "media/ni_hao.54f52474.mp3";